import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class PriceListsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object:
                [
                    {
                        'code': "NVM",
                        'description' : "Pedidos Ya",
                        'name': "SB&SM",
                        'customers': []
                    },
                    {
                        'code': "FCO",
                        'description' : "Boulan",
                        'name': "CF&CO",
                        'customers': []
                    },
                ],
            errors: []
        }
    }

    priceLists() {
        const priceLists = this.content()
        return priceLists.map(price_list => {
            return {
                code: price_list.code,
                name: price_list.name,
            }
        })
    }
}